import simpleParallax from 'simple-parallax-js'

const parallax = function () {
	var parallaxImages = document.querySelectorAll('[data-parallax]');
	// loop all images and assign appropriate opts per parallax type
	for (var i = 0; i < parallaxImages.length; i++) {
		console.log(`parallax image found: ${parallaxImages[i].src}`)
		let opts
		switch (parallaxImages[i].dataset.parallax) {
			case 'general':
				opts = {

				}
				break;
			case 'decoration':
				opts = {
					overflow: true,
					maxTransition: 80,
					scale: 2
				}
				break;
		}
		new simpleParallax(parallaxImages[i], opts);
	}
}

export default parallax
